module.exports = __webpack_public_path__ + "static/media/ecommerce.6a1cd62e.png";